import { Component, AfterViewInit, ViewChild, ElementRef } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Configuracoes } from "src/app/core/entities/configuracoes";
import { UsuarioService } from "src/app/core/services/usuario-service";
import { HttpClient } from "@angular/common/http";
import { map } from "rxjs/operators";
import { WebPageService } from "src/app/core/services/web-page.service";

@Component({
  selector: "app-page-info",
  templateUrl: "./page-info.component.html",
  styleUrls: ["./page-info.component.css"],
})
export class PageInfoComponent {
  @ViewChild("meuIFrame", { static: false }) meuIFrame: ElementRef;
  public text: String;
  // public url: String = 'http://hml.agilb2b.com.br/pt-BR/custom/1/'
  public url: String = "http://hml.agilb2b.com.br/custom/1/";
  public height: String = "2935px";
  pageContent: string = "";

  ngOnInit() {
    const url = "http://192.168.0.111:8080/";
    this.webPageService.getPageContent(url).subscribe((content: string) => {
      this.pageContent = content;
    });

    // this.getPageHeight(url).subscribe(height => {
    //   console.log('Altura da página:', height);
    // });
  }

  constructor(
    private route: ActivatedRoute,
    private usuarioService: UsuarioService,
    private webPageService: WebPageService,
    private http: HttpClient,
    private el: ElementRef
  ) {
    this.route.params.subscribe((params) => {
      if (params["pageId"]) {
        let temp = Configuracoes.SITE.infoPage.filter(
          (i) => i["pageId"] == params["pageId"]
        )[0];
        this.usuarioService.getInfoPageHtml(
          temp["id"],
          function (resp) {
            this.text = resp.html;
          }.bind(this)
        );
      }
    });
  }

  getPageHeight(url: string) {
    return this.http.get(url, { responseType: "text" }).pipe(
      map((htmlContent) => {
        const temporaryDiv = document.createElement("div");
        temporaryDiv.innerHTML = htmlContent;
        document.body.appendChild(temporaryDiv);

        const pageHeight = temporaryDiv.clientHeight;

        // Limpe o elemento temporário da DOM
        temporaryDiv.remove();

        return pageHeight;
      })
    );
  }
}
